import { atom } from "nanostores";

import { type Money } from "@vega-api/generated/types/money";
import { type ProspectResponse } from "@vega-api/generated/types/prospectResponse";

export type ProspectWithFormData = ProspectResponse & {
  tierLevel: string;
  notes: string;
  reasonForInclusion: string[];
  estimatedTicketSizeMin?: Money;
  estimatedTicketSizeMax?: Money;
};

export const $selectedProspectsData = atom<
  Record<string, ProspectWithFormData>
>({});

export type ValidationErrors = {
  reasonForInclusion?: string;
  estimatedTicketSizeMin?: string;
  estimatedTicketSizeMax?: string;
};

export const $validationErrors = atom<
  Partial<Record<string, ValidationErrors>>
>({});
